import React from "react";
import { LoadingProvider } from "./LoadingContext";
import { BreadcrumbProvider } from "./BreadcrumbContext";
import { AppProvider } from "./AppContext.tsx";
import { ClipboardProvider } from "./MoveCopyContext.js";
import { DashboardProvider } from "./DashboardContext.js";

function ContextWrapper({ children }) {
  return (
    <AppProvider>
      <LoadingProvider>
        <BreadcrumbProvider>
          <ClipboardProvider>
            <DashboardProvider>
              {children}
            </DashboardProvider>
          </ClipboardProvider>
        </BreadcrumbProvider>
      </LoadingProvider>
    </AppProvider>
  );
}

export default ContextWrapper;
